export enum ApiEndpoint {
  DEVELOPMENT = 'http://localhost:4240/graphql',
  ACCEPTANCE = 'https://api.acc.aws.ziggo.io/v2/api/my-enterprise/graphql',
  PREVIEW = 'https://api.prod.aws.ziggo.io/v2/api/my-enterprise-preview/graphql',
  PRODUCTION = 'https://api.prod.aws.ziggo.io/v2/api/my-enterprise/graphql',
}
